import type { ReactNode } from 'react'

export default function ModalShell({
  children,
  className,
}: {
  children: ReactNode
  className?: string
}) {
  return (
    <div
      className={`modal-shell ds-surface shadow-2xl min-h-0 ${className || ''}`}
      onClick={(e) => e.stopPropagation()}
    >
      {children}
    </div>
  )
}

